var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigiVendorMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 23,
    height: 23,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42248_8078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6827 0.767456H20.5394C19.4239 0.804449 18.3667 1.27385 17.5911 2.07643C16.8155 2.87876 16.382 3.9513 16.3828 5.06729C16.3828 7.08837 17.945 8.98372 19.2744 10.5174C19.6291 10.9261 20.1435 11.1608 20.6844 11.1608C21.2255 11.1608 21.7399 10.9261 22.0943 10.5174C23.4203 8.98372 24.9825 7.08811 24.9825 5.06729C24.9832 3.9513 24.5498 2.87876 23.7742 2.07643C22.9986 1.27385 21.9413 0.80444 20.8259 0.767456H20.6827ZM22.1158 5.06729C22.1158 5.44746 21.9649 5.8119 21.6962 6.08084C21.4272 6.34953 21.0628 6.5005 20.6826 6.5005C20.3024 6.5005 19.938 6.34953 19.6691 6.08084C19.4004 5.8119 19.2494 5.44747 19.2494 5.06729C19.2494 4.68712 19.4004 4.32242 19.6691 4.05374C19.938 3.78505 20.3024 3.63383 20.6826 3.63383C21.0628 3.63383 21.4272 3.78505 21.6962 4.05374C21.9649 4.32244 22.1158 4.68711 22.1158 5.06729Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.675141 17.7282V8.39826C0.678553 8.24136 0.702301 7.8578 0.769998 7.57874C0.845883 7.82491 1.13681 8.02844 1.27279 8.09943L10.2043 12.5486V24.1694C7.90223 23.0073 3.02591 20.5371 1.93687 19.9527C0.847826 19.3684 0.64195 18.2262 0.675141 17.7282Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1152 24.1198V12.3147L16.4854 10.1321C18.3971 13.2772 20.7433 13.3251 21.6775 12.956V17.7098C21.5858 19.0176 20.7344 19.8102 20.3202 20.043L12.1152 24.1198Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9225 10.7662L1.75781 6.20204L4.28536 4.91098L13.4319 9.51151L10.9225 10.7662Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41016 3.84057L15.3226 8.29678C14.1861 6.47911 14.467 4.16455 14.7495 3.23448L12.4101 2.04976C11.3002 1.49371 10.2938 1.81807 9.92928 2.04976L6.41016 3.84057Z",
    fill: "#5D5FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42248_8078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.397461 0.139771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiVendorMenuIconFilled);
export default __webpack_public_path__ + "static/media/DigiVendorMenuIconFilled.4ce167cc932455e7bfafa28ab39b02bd.svg";
export { ForwardRef as ReactComponent };